import { jsx as _jsx } from "react/jsx-runtime";
import { Quaternion } from "core/Maths/math.vector";
import { ControlledQuaternionPropertyLine, ControlledRotationVectorPropertyLine, ControlledTensorPropertyLine, } from "./vectorPropertyLineCore";
function CreateCoreTensorAdapter(components) {
    return {
        components,
        getComponent: (value, component) => {
            switch (component) {
                case "x":
                    return value.x;
                case "y":
                    return value.y;
                case "z":
                    return "z" in value ? value.z : 0;
                case "w":
                    return "w" in value ? value.w : 0;
            }
        },
        withComponent: (value, component, componentValue) => {
            const result = value.clone();
            switch (component) {
                case "x":
                    result.x = componentValue;
                    break;
                case "y":
                    result.y = componentValue;
                    break;
                case "z":
                    if ("z" in result) {
                        result.z = componentValue;
                    }
                    break;
                case "w":
                    if ("w" in result) {
                        result.w = componentValue;
                    }
                    break;
            }
            return result;
        },
    };
}
const Vector2Adapter = CreateCoreTensorAdapter(["x", "y"]);
const Vector3Adapter = CreateCoreTensorAdapter(["x", "y", "z"]);
const Vector4Adapter = CreateCoreTensorAdapter(["x", "y", "z", "w"]);
const QuaternionTensorAdapter = CreateCoreTensorAdapter(["x", "y", "z", "w"]);
const QuaternionAdapter = {
    quaternion: QuaternionTensorAdapter,
    euler: Vector3Adapter,
    fromEuler: (value) => Quaternion.FromEulerAngles(value.x, value.y, value.z),
    toEuler: (value) => value.toEulerAngles(),
};
/**
 * Edits a Babylon.js Vector2 value.
 * @param props The controlled vector and property-line presentation.
 * @returns The Vector2 property line.
 */
export const Vector2PropertyLine = (props) => _jsx(ControlledTensorPropertyLine, { ...props, adapter: Vector2Adapter });
/**
 * Edits a Babylon.js Vector3 value.
 * @param props The controlled vector and property-line presentation.
 * @returns The Vector3 property line.
 */
export const Vector3PropertyLine = (props) => _jsx(ControlledTensorPropertyLine, { ...props, adapter: Vector3Adapter });
/**
 * Edits a Babylon.js Vector4 value.
 * @param props The controlled vector and property-line presentation.
 * @returns The Vector4 property line.
 */
export const Vector4PropertyLine = (props) => _jsx(ControlledTensorPropertyLine, { ...props, adapter: Vector4Adapter });
/**
 * Edits a Babylon.js Euler rotation value.
 * @param props The controlled rotation and property-line presentation.
 * @returns The Euler rotation property line.
 */
export const RotationVectorPropertyLine = (props) => (_jsx(ControlledRotationVectorPropertyLine, { ...props, adapter: Vector3Adapter }));
/**
 * Edits a Babylon.js Quaternion value with optional Euler presentation.
 * @param props The controlled quaternion and property-line presentation.
 * @returns The quaternion property line.
 */
export const QuaternionPropertyLine = (props) => _jsx(ControlledQuaternionPropertyLine, { ...props, adapter: QuaternionAdapter });
//# sourceMappingURL=vectorPropertyLine.js.map